import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function SoundIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M8.269 2.001a.42.42 0 0 1 .335.126c.096.102.096.32.096.759v10.228c0 .438 0 .657-.096.76a.42.42 0 0 1-.335.125c-.148-.01-.319-.166-.662-.476l-2.532-2.29a1.7 1.7 0 0 0-.288-.232 1 1 0 0 0-.231-.087c-.092-.02-.19-.02-.386-.02H2.78c-.448 0-.672 0-.843-.079a.77.77 0 0 1-.35-.316c-.087-.155-.087-.357-.087-.763V6.264c0-.405 0-.608.087-.763a.77.77 0 0 1 .35-.316c.17-.08.395-.079.843-.079h1.39c.196 0 .294 0 .386-.02a1 1 0 0 0 .231-.087c.08-.045.15-.107.288-.232l2.532-2.29c.343-.31.514-.465.662-.476m3.617 2.312a1 1 0 0 1 1.402.182A5.72 5.72 0 0 1 14.5 8a5.7 5.7 0 0 1-1.212 3.504 1 1 0 0 1-1.584-1.22A3.72 3.72 0 0 0 12.5 8a3.72 3.72 0 0 0-.796-2.284 1 1 0 0 1 .182-1.403" /></svg>
  );
}

export default SoundIcon;
